import { Link } from "react-router-dom/cjs/react-router-dom.min";

const pageNotFound =() => {
    return (
        <div className="not-found-container">
            <h1>This feature is disabled</h1>
            <p>New API consumers should use OAuth client management tool: <a href='https://principal.atlassian.net/wiki/x/TXVoDQ' target='_blank' rel='noopener noreferrer'>OAuth Client Management Application</a>
            {' '}You will also use that tool to manage any scopes your application requires.
Once the application is created in that tool, it must be deployed to Apigee in all the environments via the 'Deployment' tab
Once it is deployed to Apigee in all the environments, you will be able to submit <a href='https://apigateway.workforce.principal.com/#/addgrouptoexistingconsumer' target='_blank' rel='noopener noreferrer'>Add Proxy Group To Consumer</a> for Apigee product access.</p>
            <Link to="/">Go To Homepage</Link>
        </div>
    );
};
export default pageNotFound;
